import { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  IFeatures,
  ISubscriptionPackage,
} from "./SubscriptionPackageViewController";
import {
  FormRightModalWrapper,
  ICModal,
  Loader,
} from "../../core-component/ui";
import { formatDuration } from "../../utils/AppFunctions";
import { infoIcon } from "../../assets/icons/SvgIconList";

interface ISubscriptionPackageFormProps {
  handleClose: (status: boolean) => void;
  subscriptionPackageToView: ISubscriptionPackage;
}

const SubscriptionPackageForm: React.FC<ISubscriptionPackageFormProps> = ({
  handleClose,
  subscriptionPackageToView,
}) => {
  const { t } = UseTranslationHook();
  const [loading, setLoading] = useState(false);
  const [
    subscriptionPackageInitialValues,
    setSubscriptionPackageInitialValues,
  ] = useState<ISubscriptionPackage>();
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectShow, setSelectShow] = useState<IFeatures>();
  useEffect(() => {
    getSubscriptionPackageById();
  }, []);
  const getSubscriptionPackageById = () => {
    setLoading(true);

    setSubscriptionPackageInitialValues(subscriptionPackageToView);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {subscriptionPackageInitialValues && (
            <FormRightModalWrapper
              containerClassName="!w-1/3"
              onClose={() => handleClose(false)}
              title={subscriptionPackageInitialValues.name}
              mutedTitle={formatDuration(
                subscriptionPackageInitialValues.validity
              )}
            >
              <div className="pb-4 px-4 bg-base rounded-md ">
                <div className="border-b pb-4">
                  {subscriptionPackageInitialValues.features &&
                    subscriptionPackageInitialValues.features.length > 0 &&
                    subscriptionPackageInitialValues.features.map(
                      (item, index) => (
                        <div className="mt-4" key={item.feature_title}>
                          <div className="flex items-center">
                            <div>{item.feature_title}</div>
                            {item.annotation && (
                              <div className="text-sm text-muted ml-2">
                                {item.annotation}
                              </div>
                            )}
                            {item.help_text && (
                              <div
                                className="ml-2 size-5 cursor-pointer"
                                onClick={() => {
                                  setSelectShow(item);
                                  setIsShowModal(true);
                                }}
                              >
                                {infoIcon}
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    )}
                </div>
                <div className="border-b pb-4">
                  <div className="flex mt-4 ">
                    <div className="text-sm text-muted">
                      {t("base_price")} :
                    </div>
                    <div className="ml-2">
                      ₹{subscriptionPackageInitialValues.base_price}
                    </div>
                  </div>
                  <div className="flex items-center mt-4">
                    <div className="text-sm text-muted">{t("sgst")} :</div>
                    <div className="ml-2">
                      ₹{subscriptionPackageInitialValues.sgst}
                    </div>
                  </div>
                  <div className="flex items-center mt-4">
                    <div className="text-sm text-muted">{t("cgst")} :</div>
                    <div className="ml-2">
                      ₹{subscriptionPackageInitialValues.cgst}
                    </div>
                  </div>
                  <div className="flex items-center mt-4 ">
                    <div className="text-sm text-muted">{t("igst")} :</div>
                    <div className="ml-2">
                      ₹{subscriptionPackageInitialValues.igst}
                    </div>
                  </div>
                  <div className="flex items-center mt-4 ">
                    <div className="text-sm text-muted">{t("total")} :</div>
                    <div className="ml-2">
                      ₹{subscriptionPackageInitialValues.total}
                    </div>
                  </div>
                </div>
                <div className="flex items-center mt-4">
                  <div className="text-sm text-muted">
                    {subscriptionPackageInitialValues.description}
                  </div>
                </div>
              </div>
            </FormRightModalWrapper>
          )}
          {isShowModal && selectShow && (
            <ICModal
              title={selectShow.feature_title}
              onClose={() => setIsShowModal(false)}
              children={selectShow.help_text}
            />
          )}
        </>
      )}
    </>
  );
};
export default SubscriptionPackageForm;
